<template>
  <Page>
    <PageContent>
      <SealFormCreate />
    </PageContent>
  </Page>
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import SealFormCreate from '@/components/deepSign/sealSettings/seal/SealFormCreate.vue'
import Page from '@/components/page/Page.vue'
import PageContent from '@/components/page/PageContent.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepsign.seal.create_seal',
  },
})

const { permissions } = useAuthorizationContext()

usePageAccess(computed(() => !permissions.canManageCertificates))
</script>
